import React, { Component } from "react";
import axios from "axios";
import FeatherIcon from "feather-icons-react";
import ReactToPrint from "react-to-print";
import UserIdentity from "../../users/UserIdentity";
import Headerpdf from "../../users/Headerpdf";

class Reportcard extends Component {
  state = { studentreports: { students: [] }, loading: true, error: "" };
  componentDidMount() { this.getStudentreports(); }
  getStudentreports = async () => {
    try {
      const response = await axios.get(`/users/students/${this.props.user}`);
      this.setState({ studentreports: response.data || { students: [] }, loading: false, error: "" });
    } catch (error) { this.setState({ loading: false, error: "Impossible de charger le parcours scolaire." }); }
  };
  openReport = (studentId) => window.open(`${process.env.REACT_APP_EVIVESOMA_STAT}/students/${studentId}`, "Ratting", "width=950,height=500,left=200,top=200,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,location=no,directories=no,status=no");

  render() {
    const students = this.state.studentreports.students || [];
    return <div className="student-profile-child">
      <div className="student-profile-child__toolbar"><span>{students.length} inscription{students.length === 1 ? "" : "s"}</span>
        {students.length > 0 && <ReactToPrint trigger={() => <button className="student-profile-print" type="button"><FeatherIcon icon="printer" size={15} /> Imprimer</button>} content={() => this.componentRef} />}
      </div>
      <div ref={(element) => (this.componentRef = element)}>
        <Headerpdf /><UserIdentity matricule={this.props.matricule} name={this.props.name} classe={this.props.classe} title={this.props.title} />
        <div className="print-customer">
          {this.state.loading && <div className="student-profile-empty">Chargement du parcours…</div>}
          {this.state.error && <div className="student-profile-empty is-error">{this.state.error}</div>}
          {!this.state.loading && !this.state.error && students.length === 0 && <div className="student-profile-empty"><FeatherIcon icon="book-open" /><span>Aucun parcours scolaire disponible.</span></div>}
          {students.length > 0 && <div className="student-profile-records">{students.map((student) => {
            const rate = student.studentmax > 0 ? ((student.studentsuccess * 100) / student.studentmax).toFixed(1) : "0";
            const classe = [student.sectionclass?.class?.short_entitled_class, student.sectionclass?.title, student.sectionclass?.section?.short_entitled_section ? `# ${student.sectionclass.section.short_entitled_section}` : ""].filter(Boolean).join(" ");
            return <button type="button" className="student-profile-record" key={student.id} onClick={() => this.openReport(student.id)}>
              <span className="student-profile-record__icon"><FeatherIcon icon="book-open" size={16} /></span>
              <span className="student-profile-record__content"><strong>{classe || "Classe non renseignée"}</strong><small>Année scolaire {student.year?.year || "inconnue"}</small></span>
              <span className="student-profile-record__value"><strong className={Number(rate) > 0 ? "is-success" : "is-warning"}>{rate} %</strong><small>progression</small></span>
              <FeatherIcon icon="external-link" size={15} />
            </button>;
          })}</div>}
        </div>
      </div>
    </div>;
  }
}
export default Reportcard;